const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f49297ce-530f-44f6-bd6c-15092e09c651",
    "data-name": "\\u041A\\u043E\\u043C\\u043F\\u043E\\u043D\\u0435\\u043D\\u0442 15 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    id: "ab30b7c2-cc66-4333-9f2b-53a1372c962b",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 29",
    cx: 10,
    cy: 10,
    r: 10,
    style: {
      fill: "#c2124f"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "bcdd1d3d-d740-49bd-9ed2-a60be716ddf0",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 248",
    x1: 13.5,
    y1: 13.65,
    x2: 6.5,
    y2: 6.65,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "1.2000000476837158px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "eba26d66-11f8-495b-8442-33d8b83f6b55",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 249",
    x1: 6.5,
    y1: 13.65,
    x2: 13.5,
    y2: 6.65,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "1.2000000476837158px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close_circle.fb8753c616c17e76942492e2c1c1a306.svg";
export { ForwardRef as ReactComponent };